export const mantleHelpModalDoc = {
  '1q3qudk':
  {
    pageId: null,
    path: '/',
  },
  '120kpr5':
  {
    pageId: '705df13d-794d-47aa-b02e-1a7538972f6d',
    path: '/targeting-and-optimization/conditions/how-to-use-the-upsell-com-to-add-conditions-and-upsells',
  },
  '18ga562':
  {
    pageId: 'ac93e0e4-36aa-4f1d-bfd4-2a812ce82d5e',
    path: '/targeting-and-optimization/testing-and-optimization/how-to-use-a-b-testing-with-your-upsell-com-widgets',
  },
  '1tye8ed':
  {
    pageId: null,
    path: '/',
  },
  'p5zh8h':
  {
    pageId: null,
    path: '/',
  },
  '12yqfsv':
  {
    pageId: '55e86d48-c3cc-44eb-af64-541751f2188f',
    path: '/targeting-and-optimization/conditions/how-do-conditions-work-on-upsell-com',
  },
  '8qknth':
  {
    pageId: '8697e09f-a86e-41c5-b5db-28850ae12ac7',
    path: '/building-upsell-flows/pre-purchase/how-to-add-upsell-com-blocks-slots-to-the-editor',
  },
  '1ban4rt':
  {
    pageId: 'a7933c60-ee6a-4d6f-a638-4789595bb464',
    path: '/editor/how-to-use-slots-and-widgets-on-upsell-com',
  },
  'unpozd':
  {
    pageId: null,
    path: '/',
  },
  'mcbrs9':
  {
    pageId: '9ae09dd1-19c2-4372-a85e-d2b8e4926f65',
    path: '/editor/how-to-create-and-place-slots-in-upsell-com',
  },
  '1km1dzw':
  {
    pageId: 'fa19812e-9f56-465d-965e-39e306223711',
    path: '/getting-started/setup-and-activation/how-to-set-upsell-com-as-your-post-purchase-upsell-app',
  },
};
